import React from 'react';
import PropTypes from 'prop-types';
import Modal from './modal';
import APIManager from "../../services/api-manager";

export default class ModalPartial extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            show: this.props.show,
            modalContent: this.defaultModalContent()
        };

        this.APIManager = new APIManager();
    }

    defaultModalContent() {
        return (
            <div className="loading">
                <p className="loading-title">LOADING</p>
                <div className="spinner">
                    <div className="rect1"></div>
                    <div className="rect2"></div>
                    <div className="rect3"></div>
                    <div className="rect4"></div>
                    <div className="rect5"></div>
                </div>
                <div className="loading-message">{ this.props.loadingMessage } </div>
            </div>
        )
    }

    onClose = () => {
        //if(this.abortController) this.abortController.abort();
        this.setState({
            show:false,
            modalContent: this.defaultModalContent()
        });
    };

    loadContent = () => {
        let url =  this.props.url;
        let success = (html) => {
            let newContent = (<div className="text-left" dangerouslySetInnerHTML={{__html: html}} />);
            this.setState({modalContent: newContent});
        };

        let failure = (response) => {
            this.setState({show: false, modalContent: response});
        };

        this.setState({ show: true}, () => {
            //set new abort controller for request
            //this.abortController = new AbortController();
            //this.signal = this.abortController.signal;
            //this.api.setAbortSignal(this.signal).getPartial(url, success, failure, true, this.signal)
            this.APIManager.getPartial(url, success, failure, true, this.signal)
        })
    };

    render (){
        return (
            <div>
                <div id={ this.props.id } className={ this.props.class } onClick={ this.loadContent } >{this.props.buttonText}</div>
                <Modal onClose={ this.onClose } show={ this.state.show } >{ this.state.modalContent }</Modal>
            </div>
        )
    }
}

ModalPartial.propTypes = {
    'onClose': PropTypes.func,
    'url': PropTypes.string,
    'loadingMessage': PropTypes.string,
    'show': PropTypes.bool,
    'defaultModalContent': PropTypes.func
};

ModalPartial.defaultProps = {
    'show': false,
    'loadingMessage':'Retrieving destination guide content',
};
